<template>
  <div class="mobile-menu">
    <button @click="openMenu" class="menu-button">☰</button>
    <span style="display: inline-flex; width:calc(100% - 80px); height:44px; align-items: center; justify-content: center; font-weight: 800; font-size: 16px;" @click="menu('index')">
      Southern Atlantic Service
    </span>
    
    <!-- 蒙版 -->
    <div 
      v-if="isOpen" 
      class="menu-mask" 
      @click="closeMenu"
    ></div>

    <!-- 菜单 -->
    <div :class="['menu-drawer', { 'active': isOpen }]">
      <div style="padding: 10px;background-color: white;">
        <img  src="https://alive-1302662846.cos.ap-nanjing.myqcloud.com/aliveusn/logo.png" alt="" style="width: 180px;height: 80px;">
      </div>
      <nav>
        <ul>
          <li v-for="item in menuItems" :key="item.text">
            <a @click="menu(item.link)">{{ item.text }}</a>
          </li>
        </ul>
      </nav>
      <button @click="closeMenu" class="close-button">Close</button>
    </div>

  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { removeValue } from '@/utils/auth';
const router = useRouter();
import { ref } from 'vue';

const isOpen = ref(false);
const menuItems = [
  { text: 'Index', link: 'index' },
  // { text: 'Work Order', link: 'order' },
  { text: 'Management', link: 'login' },
];

const menu = (name) => {
  closeMenu()
  if (name === 'login') {
    removeValue('maintain-role')
    removeValue('maintain-token')
  }
  router.push({ name: name})
};

const openMenu = () => {
  isOpen.value = true;
};

const closeMenu = () => {
  isOpen.value = false;
};
</script>

<style scoped>
.mobile-menu {
  position: relative;
  background-color: #FEFAF3;
}

.menu-button {
  font-size: 32px;
  border: none;
  cursor: pointer;
  padding: 14px;
  background-color: #007FFF;
  color: white;
}

.menu-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 900;
}

.menu-drawer {
  position: fixed;
  top: 0;
  left: 0;
  width: 200px;
  height: 100vh;
  background: #007FFF;
  color: white;
  transform: translateX(-100%);
  transition: transform 0.3s ease;
  z-index: 10000;
}

.menu-drawer.active {
  transform: translateX(0);
}

.close-button {
  width: 100px;
  height: 50px;
  left: 50px;
  position: relative;
  background-color: transparent;
  border: 1px solid white;
  border-radius: 30px;
  padding: 0 10px;
  color: white;
  font-size: 16px;
  cursor: pointer;
}

nav {
  padding: 40px 20px;
}

ul {
  list-style: none;
  padding: 0;
}

li {
  margin: 15px 0;
}

a {
  color: white;
  text-decoration: none;
}
</style>